/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Branding_HintInputs */

const cs_settings_office_branding_hint = /** @type {(inputs: Settings_Office_Branding_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchodní název na katalogových listech. Firemní identita (IČO, adresa) je u právnické osoby.`)
};

const en_settings_office_branding_hint = /** @type {(inputs: Settings_Office_Branding_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing name on catalog cards. Company identity (IČO, address) lives on the legal entity.`)
};

/**
* | output |
* | --- |
* | "Marketing name on catalog cards. Company identity (IČO, address) lives on the legal entity." |
*
* @param {Settings_Office_Branding_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_branding_hint = /** @type {((inputs?: Settings_Office_Branding_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Branding_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_branding_hint(inputs)
	return cs_settings_office_branding_hint(inputs)
});